import axios from "axios";
import Swal from "sweetalert2";
import config from "../../settings/config";
import { handleError } from "../../network/servicErrorHandling";

async function profileDetail() {
  return Promise.resolve().then((v) =>
    axios
      .get(config.baseUrl + "v1/users/profile")
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleError(err);
      })
  );
}
async function editProfile(params) {
  return Promise.resolve().then((v) =>
    axios
      .put(config.baseUrl + "v1/users/", params)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleError(err);
      })
  );
}

async function deleteProfileImage() {
  return Promise.resolve().then((v) =>
    axios
      .delete(config.baseUrl + "v1/users/image")
      .then((res) => {
        if (res.status === 204 || res.status === 204) {
          Swal.fire({
            icon: "success",
            text: "با موفقیت حذف شد",
            showConfirmButton: false,
            timer: 1500,
          });
        } else {
          Swal.fire({
            icon: "error",
            text: "حذف نشد دوباره امتحان کنید",
            showConfirmButton: false,
            timer: 1500,
          });
        }
        return res.status;
      })
      .catch((err) => {
        handleError(err);
      })
  );
}

export { profileDetail, editProfile, deleteProfileImage };
